import { LogActionTypes, LogEntityTypes } from 'types/graphql'

export const PLAN_AND_KPI_ACTIVITIES_FILTERS = [
  { label: 'Attachments', value: LogEntityTypes.Image, stateKey: 'attachments' },
  { label: 'Links', value: LogEntityTypes.Link, stateKey: 'links' },
  { label: 'Comments', value: LogEntityTypes.Comment, stateKey: 'comments' },
  { label: 'Record updates', value: LogActionTypes.Update, stateKey: 'recordUpdates' }
]

export const ACTION_AND_OBJECTIVES_ACTIVITIES_FILTERS = [
  { label: 'Attachments', value: LogEntityTypes.Image, stateKey: 'attachments' },
  { label: 'Links', value: LogEntityTypes.Link, stateKey: 'links' },
  { label: 'Comments', value: LogEntityTypes.Comment, stateKey: 'comments' },
  { label: 'Resources', value: LogEntityTypes.Resource, stateKey: 'resources' },
  { label: 'Record updates', value: LogActionTypes.Update, stateKey: 'recordUpdates' }
]
